import { Skeleton } from "@/components/ui/skeleton";

export const SkeletonSidebar = () => (
  <aside className="w-64 p-4 space-y-2">
    {Array.from({ length: 8 }).map((_, i) => (
      <Skeleton key={i} className="h-6 w-full" />
    ))}
  </aside>
);

export const SkeletonGrid = ({ isGrid }: { isGrid: boolean }) => (
  <div
    className={
      isGrid
        ? "grid grid-cols-[repeat(auto-fill,minmax(160px,1fr))] gap-4 flex-1"
        : "flex flex-col gap-4 flex-1"
    }
  >
    {Array.from({ length: 10 }).map((_, i) => (
      <Skeleton key={i} className="h-[180px] w-full" />
    ))}
  </div>
);
export const GlobalSkeleton = () => (
  <div className="flex flex-col gap-6 p-4 animate-pulse">
   
    <Skeleton className="h-8 w-48 mx-auto rounded-xl" />

    <div className="flex flex-col md:flex-row gap-6">
      <SkeletonSidebar />              
      <SkeletonGrid isGrid />  
    </div>
  </div>
);